module.exports = __webpack_public_path__ + "img/bell-white.6ac0d08e.svg";